module.exports = __webpack_public_path__ + "img/14.4e323d36.png";